var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustedShopsSiegel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -1568.47,
    cy: 4.667,
    fx: -1568.47,
    fy: 4.667,
    r: 0.68,
    gradientTransform: "translate(470626 -1318) scale(300)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9c9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#656667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -1562.977,
    cy: -1.718,
    fx: -1562.977,
    fy: -1.718,
    r: 0.9,
    gradientTransform: "translate(188377.916 224649.712) rotate(49.96) scale(187.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fffdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1cb54"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m150,0c82.8,0,150,67.3,150,150.4-7.9,199.5-292.1,199.5-300,0C0,67.3,67.2,0,150,0Zm1.2,56.3c-124.6,5-124.7,183.5,0,188.5,51.9,0,94-42.2,94-94.3s-42.2-94.2-94-94.2h0Z",
    style: {
      fill: "url(#b)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m245.2,150.5c0,52.1-42.1,94.3-94,94.3-124.7-5-124.6-183.5,0-188.5,51.9-.1,94,42.1,94,94.2h0Z",
    style: {
      fill: "url(#d)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "m249.7,115.8l9.8-3c.6,3.9,3.1,8.5,6.2,10.1,3.9,2.5,11.2.2,12.6-4.5,2-3.8-1.9-14-3.6-17.2l-26.9,8.4s1.9,6.2,1.9,6.2Zm22.5-7.1c1.6,2.9,2.3,7.5-1.5,8.6-3.6,1.3-6.2-2.4-6.6-6.1l8.1-2.5h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m237.2,91.7c4.6,7,12.4,8.5,20.3,3.3,16.4-10.7.8-33.7-15.7-22.6-6.8,4.6-9.4,12.3-4.6,19.3h0Zm8.4-13.6c4.6-3,9.5-3.2,11.9.4,5.2,7.6-11.3,18.4-16.1,10.7-2.2-3.7-.4-8,4.2-11.1h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    points: "211.9 64.7 219.5 55.4 227.8 62 220.2 71.4 225.2 75.4 243.1 53.2 238.2 49.1 231.3 57.7 223 51 229.9 42.4 224.9 38.4 207 60.6 211.9 64.7",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m190.1,53c7.2,3.1,12.1.8,14-3.5,1.6-3.8.5-7.1-3.4-10.7-2.8-2.7-3.9-4.2-3.2-5.8.6-1.3,2.3-2,4.9-.9,2.5,1.1,4.1,2.6,4.9,3.7l3.3-4.1c-4.9-5.6-16.2-8.4-19.4-.6-1.6,3.9.2,7.5,3.8,10.9,2.7,2.4,3.5,4,2.8,5.6-1.9,4.5-9.7-1.1-11.2-3.4l-3.3,4.3c1.2,1.1,3.8,3.2,6.8,4.5h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m160.8,19.1c-3.9-3.8-14.6-3.6-20.3-2.7l-.5,28c5.8,1,16.3,1,20.6-2.9,5.9-4.5,6.9-17.7.2-22.4Zm-12.1,20.8c-.8,0-1.7,0-2.2-.2l.3-18.7c6.3-1.1,12.1,1.6,11.8,9-.1,7-4,10.1-9.9,9.9Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "l",
    points: "132.9 45.7 131.6 40.5 120.3 43.4 118.6 36.8 128.8 34.2 127.5 29.1 117.3 31.8 115.8 26 126.6 23.2 125.2 18 108.3 22.5 115.3 50.2 132.9 45.7",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "m",
    points: "85.9 38.7 96.9 59 102.5 55.9 91.5 35.5 98.4 31.8 95.8 27 76.5 37.5 79.1 42.3 85.9 38.7",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m69.6,64.7c3.3-1.4,5.1-1.6,6.3-.3,3.2,3.7-4.9,8.4-7.7,8.9l2.6,4.8c1.8-.4,4.8-1.9,7.2-4.2,5.8-5.3,5.8-10.7,2.5-14.3-2.7-2.9-6.2-3.3-11.2-1.3-3.7,1.5-5.3,1.9-6.7.6-2.7-3.1,4.3-7.5,6.5-7.9l-2.4-4.8c-7.1,2.1-14.2,11.3-8.5,17.5,2.7,3.1,6.8,2.9,11.4,1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "m60.9,94.8c3.9-6.3,2.7-12.3-4.7-17l-13.5-8.5-3.4,5.5,13.8,8.7c4.3,2.7,5.3,5.6,3.5,8.4-1.7,2.7-4.8,3-9.1.4l-13.8-8.7-3.4,5.4,13.4,8.5c7.8,4.8,13.4,3.4,17.2-2.7h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "m47.8,124.2l-10.8-3.1.5-1.8c.8-2.5,2-3.4,5.7-3.2,3.6.2,6,.1,7,0l1.8-6.4c-1.2.2-5,0-8.4,0-2.7,0-4.8.5-6.2,2.2h-.1c-.2-5.5-7-9.3-11.8-5.9-3.8,2.3-6,12.5-6.6,16.7l27.1,7.8,1.8-6.3h0Zm-14.6-6.7l-.7,2.4-7.5-2.1c.3-2.9,1.7-7.6,5.7-6.4,2.4.6,3.4,2.9,2.5,6.1h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "q",
    points: "44.8 144.3 21.6 143.8 21.8 135.9 16.5 135.8 15.9 157.8 21.3 157.9 21.5 150.1 44.5 150.8 44.8 144.3",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "m50.8,223.2l2.9,4.8-7,4.4c-6.1-5-7.4-13.9.7-18.6,8.3-5.5,16.3,1.1,17.5,9.4l2.9-.8c-1.8-10.9-12.8-18.3-22.6-11.9-11.5,7.2-7,19.4,1.4,25.9l11.3-7-4.8-7.8-2.3,1.6h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "m86.4,237.9l-10.5,12.7c-3.9,4.7-7.7,5.1-10.8,2.4-2.8-2.3-3.2-6.2.7-10.8l10.5-12.6-2.7-2.3-10.6,12.4c-5.6,6.6-4.3,11.9,0,15.5,4.6,3.8,10.2,4.1,15.7-2.4l10.4-12.4-2.7-2.5h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "m81.1,267.8l3.3,1.5,6.2-6.8,8.9,4-.9,9.1,3.4,1.6,2.8-29.2-3.8-1.7-19.9,21.5h0Zm20.6-17.5c-.7,3.1-1.2,10.2-1.6,13.6l-7.6-3.4c2.3-2.6,7.2-7.6,9.2-10.2h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "m126.1,254.7c-2.4-.5-4.9-.7-6.9-.8l-5.2,26.8,3.5.7,2.3-11.8,3.3.6c3.1.7,4.3,2.4,4.4,6.4.1,3.5.2,6,.5,6.9l3.6.7c-.4-1.1-.5-4-.6-7.9-.1-2.9-.9-5.2-2.8-6.3h0c5.4-.4,8.6-7.1,5.4-11.5-1.5-1.9-3.8-3.1-7.5-3.8h0Zm4.9,9.1c-.6,3.1-3.4,4.7-7.2,4l-3.5-.7,1.9-9.9c4-.2,10,1.3,8.8,6.6Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "m150.6,257.4l-9.1,27.9h3.7l2.7-8.7,9.8-.1,3,8.7,3.8-.1-9.8-27.5-4.1-.2h0Zm-1.9,16.2c1-3.2,3.2-9.8,3.9-13.1h.1c.7,3.1,3.2,9.8,4.3,13l-8.3.1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "m186.9,252c1.7,6.4,3.9,16.3,6.1,22.2l-.1.1c-3.7-4.9-14.3-14.3-19-18.8l-3.8,1,6.9,26.7,3.2-.8c-1.6-6.2-4.2-16.9-6.1-22.5l.1-.1c4,5.2,14.4,14.3,19.3,19.1l3.5-.9-6.9-26.8-3.2.8h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "x",
    points: "213.9 242.3 212.4 239.7 194.6 249.5 196 252.1 203.3 248.1 215.1 269.8 218.3 268 206.5 246.4 213.9 242.3",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "y",
    points: "235.4 252.3 228.7 244.9 236.6 237.8 234.6 235.5 226.7 242.8 220.8 236.3 229.1 228.6 227.1 226.4 216.1 236.6 234.8 257 246.3 246.5 244.2 244.2 235.4 252.3",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "z",
    points: "254 231.6 245.7 226.1 251.5 217.1 249 215.6 243.2 224.6 235.9 219.8 242 210.2 239.5 208.6 231.4 221.1 254.6 236.2 263 223.2 260.5 221.4 254 231.6",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    d: "m284.2,144.6c-.3-6.7-4.2-10.6-9.1-10.3-4.1.2-6.6,3.5-8.1,8.3-1,3.5-1.9,4.9-3.7,5-4.9.2-3.3-9.2-1.9-11.6l-5.4-1c-.8,1.6-1.5,5-1.3,8.2.4,7.8,4.6,11.2,9.4,11,4-.2,6.5-2.7,8.1-7.8,1.2-3.9,1.9-5.4,3.7-5.5,4.2-.1,3,8.1,1.9,10l5.2,1.2c.8-1.9,1.3-4.2,1.2-7.5Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    d: "m38.6,183.7c-.2,7-10.3,7-10.5,0,.2-7,10.3-7,10.5,0Z",
    style: {
      fill: "#f7e19e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "m271.5,183.7c-.2,7-10.3,7-10.5,0,.2-7,10.3-7,10.5,0Z",
    style: {
      fill: "#f1cb53",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    d: "m169.1,88.2c16.2,0,27.5,7.7,29.6,20.2,1.2,6.7-.3,12.6-2.3,17.1l-.3.6c-.1.2-.2.4-.3.6l-.3.6c-.3.5-.5,1-.8,1.4l-.3.5h0l-.3.5h0l-.3.5c-.1.1-.1.2-.2.2l-.3.5h0l-.3.4h0l-.3.4-.2.2-.3.4h0l-.4.6c0,.1-.1.1-.1.2l-.4.5h0l-.4.4h0c-6.1,6.8-15.8,12.6-29.5,17.9l-1.5.6h0c-9.1,3.4-18.5,5.9-27.8,8l-2.9.7h0l-2.9.6h0l-4.3.9h0c-.9,22.2,4.8,33.7,17.4,35.3,1.1.1,2.3.2,3.4.2,7.2,0,13.2-2.9,18-6.1l.7-.5h0l.7-.5h0l.7-.5h0l.7-.5h0l1-.7h0c6.3-5,11.3-10.8,15.4-16.7l1.5-2,6.9,6-.4.5-.9,1.3c-.5.7-.9,1.3-1.4,2l-.9,1.3c-5.8,8.1-11.7,14.8-19.9,20.1l-.7.4c-.1.1-.2.1-.4.2l-.7.4c-.6.4-1.3.8-1.9,1.1l-.8.4h0l-.8.4c-6.7,3.4-15.6,6.6-25.9,6.6-2.4,0-4.9-.2-7.3-.5-18.8-2.7-29.4-16.3-29.7-38.3v-.7c-.2-20.2,6.1-38.9,18.8-55.4l.5-.6c14-18,30.9-27.2,51.6-28.2.1.6.8.5,1.5.5h0Zm-6.8,9.8c-.8,0-1.7.1-2.5.2l-.5.1c-8.8,1.5-15.1,7.2-20.2,14l-.6.8c-.1.1-.2.3-.3.4l-.6.8h0l-.6.8h0l-.6.8h0l-.6.8h0l-.5.8h0l-.5.9h0l-.5.9h0c-5.9,9.5-9.7,20.5-11.9,33.5,13.1-2.3,24.9-6.8,34.2-12.9,12.9-8.5,19.2-18.5,18.7-29.6-.6-7.2-5.7-12.3-13-12.3h0Z",
    style: {
      fill: "#006dad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    d: "m97.2,173c-.2-20.6,6.1-39.8,19-56.5,13.9-18,31.9-26.7,52.5-27.7.8,0,1.5-.1,2.2-.1,4.2,0,8.2.6,11.6,1.6-4.6-2.1-9.9-3.2-16.1-3.2-.7,0-1.5,0-2.2.1-20.6.9-37.5,10.1-51.4,28.2-12.9,16.6-19.4,35.5-19.2,56,.2,19.9,9.1,32.7,24.2,37.3-12.3-5.8-20.5-17.8-20.6-35.7h0Z",
    style: {
      fill: "#044d73",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    d: "m146.2,200.2c9.2,0,15.1-5.2,20.4-9.3,6.6-5.2,12.8-12.3,17.1-18.3l-2.6-2.3-1.2,1.7c-4.4,6.2-9.7,12.5-16.5,17.8-5.2,4.1-12.4,8.4-21.6,8.4-1.1,0-2.1-.2-3.2-.3-.7-.1-2.2-.4-2.8-.6,1.9,1,4.5,2.5,7,2.8,1.1,0,2.2.1,3.4.1h0Z",
    style: {
      fill: "#044d73",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    d: "m174.8,110.6c.6,11.1-5.7,21.1-18.6,29.6-8.1,5.4-22.7,10.1-33.8,12.6-.2,1-.1.5-.2,1.4,13-2.3,29.1-6.2,38.4-12.4,12.8-8.5,19.1-18.5,18.6-29.6-.3-6.6-4.1-11.4-10.1-12.4,3.4,2,5.4,5.9,5.7,10.8h0Z",
    style: {
      fill: "#044d73",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedShopsSiegel);
export default __webpack_public_path__ + "static/media/trusted_shops_siegel.87f15031e7133d1e36c55a7faaa1b10e.svg";
export { ForwardRef as ReactComponent };